export default function Page ({ children }) {
  return <>{children}</>;
}
